/**
 * 预览子组件-价格组件
 * @author chenqunfeng
 * @since 18/03/27
 */

import './price.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import VARIABLE from 'constants/variable.json5';

class PreviewPrice extends Component {
  static propTypes = {
    data: PropTypes.object,
    coupon: PropTypes.object,
    newClassName: PropTypes.string,
  };

  // 价格转化为对应的文本
  priceToText(price) {
    if (price === 0 || (price && !isNaN(price))) {
      if (price === 0) {
        return '免费';
      } else {
        const fixedPrice = price.toFixed(2);

        if (fixedPrice === '0.00') {
          return '免费';
        } else {
          return `${price.toFixed(2)}元`;
        }
      }
    }
    return false;
  }

  // 获取最优的优惠价格
  getDiscountPrice() {
    const { data = {}, coupon = {} } = this.props;
    const { tplPrice, tplOrganizePrice, minimumPrice } = data;
    const { couponPrice } = coupon;
    let discountPrice = +tplPrice;

    if (tplOrganizePrice !== null && +tplOrganizePrice < discountPrice) {
      discountPrice = +tplOrganizePrice;
    }
    if (minimumPrice !== null && +minimumPrice < discountPrice) {
      discountPrice = +minimumPrice;
    }
    if (couponPrice !== null && +couponPrice < discountPrice) {
      discountPrice = +couponPrice;
    }

    return discountPrice;
  }

  render() {
    const { data = {}, newClassName = '' } = this.props;
    const { tplPrice, category, pluginId } = data;
    const discountPrice = this.getDiscountPrice();
    const tplPriceText = this.priceToText(tplPrice);
    const discountPriceText = this.priceToText(discountPrice);
    const invoiceText = <span className="invoice-info">支持开企业发票</span>;

    // 插件作品 不显示
    if (pluginId) {
      return null;
    }

    // 企业专区和我的模版,能看到这些模版则表明可以免费使用,但是不显示价格
    if (category === VARIABLE.ENTERPRISE || category === VARIABLE.MY_TPL) {
      return null;
    }

    if (!tplPriceText && !discountPriceText) {
      return (
        <div className={`s-preview-price ${newClassName}`}>
          <p>原价: --</p>
          {invoiceText}
        </div>
      );
    }

    // 免费作品,直接返回
    if (tplPriceText === '免费') {
      return (
        <div className={`s-preview-price ${newClassName}`}>
          <p className="s-preview-ori-price">{tplPriceText}</p>
          {invoiceText}
        </div>
      );
    }

    // 其余情况
    return (
      <div className={`s-preview-price ${newClassName}`}>
        {discountPrice < tplPrice && (
          <p className="s-preview-vip-price s-preview-cur-price ">
            <span>{discountPriceText}</span>
          </p>
        )}
        <p
          className={
            discountPrice < tplPrice ? 's-preview-line' : 's-preview-ori-price'
          }>
          {`${discountPrice < tplPrice ? '原价:' : ''}${
            tplPriceText ? tplPriceText : ''
          }`}
        </p>
        {invoiceText}
      </div>
    );
  }
}

export default PreviewPrice;
